import { Box, Typography, Button } from '@mui/material';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';

const wiggleAnimation = {
    animate: {
        rotate: [-2, 2, -2],
        transition: {
            repeat: Infinity,
            duration: 1,
            ease: 'easeInOut',
        },
    },
};

const bounceAnimation = {
    animate: {
        y: [0, -10, 0],
        transition: {
            repeat: Infinity,
            duration: 1.5,
            ease: 'easeInOut',
        },
    },
};


const BouncingCTA = ({ text, link, linkText = 'Learn more', bgImage }) => {
    return (
        <Box
            component={motion.div}
            {...bounceAnimation}
            sx={{
                mt: 4,
                p: 3,
                borderRadius: 2,
                textAlign: 'center',
                maxWidth: 600,
                mx: 'auto',
                color: 'white',
                position: 'relative',
                overflow: 'hidden',
                backdropFilter: bgImage ? 'blur(8px)' : 'none',
                backgroundColor: bgImage
                    ? 'rgba(0,0,0,0.5)'
                    : 'rgba(25, 118, 210, 0.1)',
                border: bgImage ? 'none' : '2px dashed #1976d2',
            }}
        >
            {bgImage && (
                <Box
                    sx={{
                        position: 'absolute',
                        top: 0,
                        left: 0,
                        width: '100%',
                        height: '100%',
                        backgroundImage: `url(${bgImage})`,
                        backgroundSize: 'cover',
                        backgroundPosition: 'center',
                        filter: 'blur(3px) brightness(0.7)',
                        zIndex: 0,
                    }}
                />
            )}

            <Box sx={{ position: 'relative', zIndex: 1 }}>
                <Typography variant="body1" sx={{ fontWeight: 1000, mb: 1, color: '#fff' }}>
                    {text}&nbsp;
                </Typography>
                <Button
                    variant="text"
                    size="large"
                    component={Link}
                    to={link}
                    sx={{
                        fontWeight: 'bold',
                        textTransform: 'none',
                        color: '#fff',
                        textDecoration: 'underline',
                        p: 0,
                        minWidth: 0,
                        fontSize: '1.2rem',
                    }}
                >
                    {linkText}
                </Button>
            </Box>
        </Box>
    );
};

export default BouncingCTA; 